import { type ComputedRef, onActivated, onDeactivated, onMounted, onUnmounted, watch } from 'vue';

import { useStore } from '@/store';

export function useRootAppName(name: string) {
    const store = useStore();
    bindHooks(
        () => {
            store.rootAppName = name;
        },
        () => {
            if (store.rootAppName === name) {
                store.rootAppName = null;
            }
        }
    );
}

export function useSubAppName(name: string | ComputedRef<string>) {
    const store = useStore();

    let nameStr = typeof name === 'string' ? name : name.value;

    bindHooks(
        () => {
            store.subAppName = nameStr;
            if (typeof name !== 'string') {
                watch(name, newVal => {
                    store.subAppName = newVal;
                    nameStr = newVal;
                });
            }
        },
        () => {
            if (store.subAppName === nameStr) {
                store.subAppName = null;
            }
        }
    );
}

export function useIsMobileReady() {
    const store = useStore();
    bindHooks(
        () => {
            store.isMobileReady = true;
        },
        () => {
            store.isMobileReady = false;
        }
    );
}

function bindHooks(inHook: () => void, outHook: () => void) {
    onMounted(inHook);
    onActivated(inHook);
    onDeactivated(outHook);
    onUnmounted(outHook);
}
